import React, { useState } from "react";
import { useEffect } from "react";
import useBlogCalls from "../service/useBlogCalls";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { Box, Pagination, PaginationItem, Typography } from "@mui/material";
import useNewsCalls from "../service/useNewsCalls";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { makeStyles } from "@material-ui/core/styles";
import SkipNextIcon from "@mui/icons-material/SkipNext";

const Category = () => {
  const { getData } = useBlogCalls();
  const { categories } = useSelector((state) => state.blog);
  //   console.log("🚀 ~ Category ~ categories:", categories);
  const getNewsData = useNewsCalls();
  const { news } = useSelector((state) => state.news);
  console.log("🚀 ~ Home ~ news:", news);
  const handleChange = (event, value) => {
    setPage(value);
  };
  const [page, setPage] = useState(1);

  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiPaginationItem-page.Mui-selected": {
        color: "white", // Seçili sayfa metin rengi
      },
      "& .MuiPaginationItem-page:hover": {
        color: "white", // Üzerine gelindiğinde metin rengi
      },
      "& .MuiPaginationItem-page": {
        color: "white", // Diğer sayfaların metin rengi
      },
      "& .MuiSvgIcon-root": {
        fill: "white", // İkonların rengi
      },
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    getNewsData(page);
  }, [page]);
  //   useEffect(()=>{
  //     getCategoryData("blogs", "Technology");
  //   },[])

  return (
    <div
      className="category"
      style={{
        backgroundColor: "#2b2d42",
        padding: "8px",
        borderRadius: "10px",
        paddingBottom: "16px",
        margin: "1rem",
        marginTop: "2.3rem",
        color: "white",
        mx: "auto",
        paddingRight: "1rem",
      }}
    >
      <h3 className="category-header"> Latest Tech News</h3>

      {news?.map((news) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "2rem",
            paddingLeft: "1rem",
            marginBottom: ".6rem",
            paddingBottom: ".5rem",
            borderBottom: "1px solid rgba(255,255,255,0.5)",
          }}
        ><a className="newsLink" target="_blank" href={news.link}>
          <img
            src={news.image_url}
            alt=""
            style={{
              minWidth: "70px",
              maxWidth:"70px",
              height: "70px",
              objectFit: "cover",
              borderRadius: "15px",
              border: "2px solid rgba(255,255,255,0.5)",
              boxShadow: "2px 2px 2px rgba(255,255,255,0.5)",
            }}
          /></a>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            <a className="newsLink" target="_blank" href={news.link}>
              {news.title}
            </a>
            <p className="newsLink">{moment(news.pubDate).format("MMM Do YYYY")}</p>
          </div>
        </div>
      ))}

      {/* <div
        style={{ display: "flex", justifyContent: "center", color: "white" }}
      >
        <Pagination
          defaultPage={6}
          boundaryCount={1}
          count={10}
          page={page}
          onChange={handleChange}
          color="error"
          className={classes.root}
          renderItem={(item) => (
            <PaginationItem
              slots={{ previous: SkipPreviousIcon, next: SkipNextIcon }}
              {...item}
            />
          )}
        />
      </div> */}
    </div>
  );
};

export default Category;
